var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPollTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#DC4541"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 1C4.589 1 1 4.589 1 9s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm0 15.385c-4.072 0-7.385-3.313-7.385-7.385 0-4.072 3.313-7.385 7.385-7.385 4.072 0 7.385 3.313 7.385 7.385 0 4.072-3.313 7.385-7.385 7.385z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.77 5.719l-4.73 5.32-2.848-2.28a.308.308 0 0 0-.384.481l3.077 2.462a.307.307 0 0 0 .422-.036l4.923-5.539a.307.307 0 1 0-.46-.408z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPollTick);
export default __webpack_public_path__ + "static/media/poll-tick.75a85611.svg";
export { ForwardRef as ReactComponent };